import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            '&.Mui-focused fieldset': {
              borderColor: process.env.REACT_APP_BASE_GREEN, // Bordure au focus
            },
          },
          '& .MuiInputLabel-root.Mui-focused': {
            color: process.env.REACT_APP_BASE_GREEN, // Couleur du label quand l'input est en focus
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          '&.Mui-focused': {
            color: process.env.REACT_APP_BASE_GREEN, // Change la couleur du label lorsqu'il est en focus
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          '&.MuiButton-outlined': {
            borderColor: process.env.REACT_APP_BASE_GREEN,  // Couleur de la bordure pour les boutons outlined
            color: process.env.REACT_APP_BASE_GREEN,        // Couleur du texte pour les boutons outlined
            '&:hover': {
              borderColor: process.env.REACT_APP_BUTTON_COLOR_HOVER, // Couleur de la bordure au survol
              color: process.env.REACT_APP_BUTTON_COLOR_HOVER // Couleur du texte au survol
            },
          },
          '&.MuiButton-contained': {
            backgroundColor: process.env.REACT_APP_BASE_GREEN,  // Couleur de la bordure pour les boutons contained
            color: "#ffffff",      // Couleur du texte pour les boutons contained
            '&:hover': {
              backgroundColor: process.env.REACT_APP_BUTTON_COLOR_HOVER, // Couleur de la bordure au survol
              color: "#ffffff" // Couleur du texte au survol
            },
          },
          '&.MuiButton-error': {
            borderColor: process.env.REACT_APP_BASE_RED, // Couleur de la bordure pour les boutons error
            color: process.env.REACT_APP_BASE_RED, // Couleur du texte pour les boutons error
            '&:hover': {
              borderColor: process.env.REACT_APP_BASE_RED_HOVER, // Couleur de la bordure au survol
              color: process.env.REACT_APP_BASE_RED_HOVER // Couleur du texte au survol
            },
          },
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        root: {
          // Utilisation de la couleur active pour l'état activé du Switch
          '& .MuiSwitch-switchBase.Mui-checked': {
            color: process.env.REACT_APP_BASE_GREEN,  // Couleur de la base du switch activé
            },
          '& .MuiSwitch-track': {
            backgroundColor: process.env.REACT_APP_BUTTON_COLOR_HOVER,  // Couleur de la piste du switch
          },
          '& .MuiSwitch-switchBase': {
            '&.Mui-checked': {
              '& + .MuiSwitch-track': {
                backgroundColor: process.env.REACT_APP_BUTTON_COLOR_HOVER,
              },
            },
          },
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          // Utilisation de la couleur active pour l'état activé du Checkbox
          '&.Mui-checked': {
            color: process.env.REACT_APP_BASE_GREEN,  // Couleur de la case à cocher activée
          },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          '& .MuiTab-root.Mui-selected': {
            color: process.env.REACT_APP_BASE_GREEN,
            backgroundColor: process.env.REACT_APP_DARK_GREEN_BRAKGROUND,
          },
        },
        indicator: {
          backgroundColor: process.env.REACT_APP_INDICATOR_BACKGROUND,
        }
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            color: process.env.REACT_APP_BASE_GREEN,
            backgroundColor: process.env.REACT_APP_DARK_GREEN_BRAKGROUND,
          },
        },
      },
    },
  },
});

export default theme;